<template>
  <div id="tab-bar">
    <!--  <el-container>-->
    <el-container>
      <el-header>
        <div
          v-if="brand == 'IR'"
          class="logoName fl"
          :style="{ width: isCollapse ? '57px' : '226px' }"
        >
          <img v-if="!isCollapse" src="~assets/img/logo.png" />
          <img v-if="isCollapse" src="~assets/img/HELIX_Slogo.png" />
        </div>
        <div
          v-if="brand == 'GD'"
          class="logoName fl"
          :style="{ width: isCollapse ? '57px' : '226px' }"
          style="padding-left: 10px; padding-right: 30px"
        >
          <img src="~assets/img/logo2.png" />
        </div>
        <!-- <div class="bland fl"> 
          <span >Welcome to HELIX</span>
        </div> -->
        <div class="usediv fr">
          <el-dropdown @command="password" :hide-on-click="false">
            <span class="el-dropdown-link userName">
              {{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="userDivDrop">
              <!-- <el-dropdown-item command="changeLanguage"
                              >中英文切换 {{ activeLang == "zh" ? "中文" : "英文" }}
                            </el-dropdown-item> -->
              <el-dropdown-item>
                <div class="SubTitle">{{ $t("desc.languageSwitch") }}</div>
                <el-button
                  size="small"
                  type="text"
                  :style="
                    activeLang == 'zh' ? 'color: #E62E19; ' : 'color:#828393'
                  "
                  @click="changeLanguage('zh')"
                  class="userDownBtn"
                  >中文
                </el-button>
                <span class="VerticalLine">|</span>
                <el-button
                  size="small"
                  type="text"
                  :style="
                    activeLang == 'en' ? 'color: #E62E19; ' : 'color:#828393'
                  "
                  @click="changeLanguage('en')"
                  class="userDownBtn"
                  >EN
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item divided>
                <div class="SubTitle">{{ $t("desc.brandSwitch") }}</div>
                <template v-for="(brand, index) in brandList">
                  <el-button
                    :key="brand + index"
                    size="small"
                    type="text"
                    :style="
                      brandCode == brand.brandCode
                        ? 'color: #E62E19; '
                        : 'color:#828393'
                    "
                    @click="changeBrand(brand.brandCode)"
                    class="userDownBtn"
                    >{{ brand.brandName }}
                  </el-button>
                  <span
                    :key="index"
                    v-if="index < brandList.length - 1"
                    class="VerticalLine"
                    >|</span
                  >
                </template>
                <span v-if="hasMultiAuth" class="VerticalLine">|</span>
                <el-button
                  size="small"
                  type="text"
                  style="color: #828393"
                  class="userDownBtn"
                  v-if="hasMultiAuth"
                  @click="openRoap()"
                  >RoAP
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item divided v-if="hasMultiAuth">
                <el-button
                  size="small"
                  type="text"
                  style="color: #828393"
                  class="userDownBtn"
                 
                  @click="openScreenMonior()"
                  >{{ $t("menu.MultiBrand_View") }}
                </el-button>

                <!--<template>
                  <span v-if="hasMultiAuth" class="VerticalLine">|</span>
                  <el-button
                    size="small"
                    type="text"
                    style="color: #828393"
                    class="userDownBtn"
                    v-if="isAdmin == true"
                    @click="openOMPlatform()"
                    >{{ $t("desc.linkOMPlatform") }}
                  </el-button>
                </template>
                -->
              </el-dropdown-item>
              <el-dropdown-item divided v-if="hasEmcStationMonitor">
                <el-button
                  size="small"
                  type="text"
                  style="color: #828393"
                  class="userDownBtn"
                 
                  @click="openStatioMonior()"
                  >{{ $t("menu.StationMonitor") }}
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item divided>
                <div>
                  {{ $t("desc.monitorMode") }}
                  <template>
                    <el-switch
                      v-model="isRefresh"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      style="margin-left: 20px"
                      @change="changeMonitorMode"
                    >
                    </el-switch>
                  </template>
                </div>
              </el-dropdown-item>
              <!-- <el-dropdown-item divided
                ><el-button
                  size="small"
                  type="text"
                  style="color: #828393; margin-top: 0"
                  class="userDownBtn"
                  @click="openTest()"
                  >{{ $t("menu.EnduranceManagement_View") }}
                </el-button>
              </el-dropdown-item> -->
              <el-dropdown-item
                v-if="accountType != 'sso'"
                command="edit"
                divided
                >{{ $t("desc.changePaw") }}
              </el-dropdown-item>
              <el-dropdown-item command="layout" divided
                >{{ $t("desc.LogOut") }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="topdiv fr">
          <el-button
            class="topBtn toggle-button"
            id="menuBtn"
            @click="togleCollapse"
            ><img src="~assets/img/icon_more.png"
          /></el-button>
          <!-- 如果有报警，增加数量 :value="3" @click="openWarning"-->

          <el-button
            class="topBtn"
            id="plainBtn"
            plain
            @click="openWarning"
            style="margin-left: 20px"
            v-if="hasAlarmListAuth"
          >
            <img src="~assets/img/icon_alarm.png" />
          </el-button>

          <!-- <el-badge :value="alarmNum" class="item">
            <el-button class="topBtn" id="plainBtn" plain @click="openWarning">
              <img src="~assets/img/icon_alarm.png" />
            </el-button>
          </el-badge> -->

          <!-- 如果有推送，增加数量 :value="3" -->
          <el-badge :value="messageNum" class="item" v-if="hasNoticeListAuth">
            <el-button class="topBtn" id="plainBtn" plain @click="openNotice"
              ><img src="~assets/img/icon_message.png"
            /></el-button>
          </el-badge>
        </div>
      </el-header>
    </el-container>

    <el-container>
      <el-scrollbar
        class="leftSide"
        :style="{ width: isCollapse ? '97px' : '266px' }"
      >
        <el-aside>
          <el-menu
            router
            unique-opened
            :default-active="currentPage"
            :collapse="isCollapse"
            :collapse-transition="false"
            :active="currentPage"
          >
            <template v-for="(menu, index) in menuList">
              <el-menu-item
                v-if="!menu.children || menu.children.length == 0"
                :index="menu.url"
                :key="index"
              >
                <div
                  class="iconBorder"
                  :style="{ width: isCollapse ? '29px' : '200px' }"
                >
                  <img :src="menu.icon" />
                </div>
                <span slot="title">{{ $t("menu." + menu.code) }}</span>
              </el-menu-item>
              <el-submenu v-else :index="menu.url" :key="menu.id">
                <template slot="title">
                  <div
                    class="iconBorder"
                    :style="{ width: isCollapse ? '29px' : '200px' }"
                  >
                    <img :src="menu.icon" />
                  </div>
                  <span>{{
                    activeLang == "zh" || $t("menu." + menu.code) == null
                      ? menu.name
                      : $t("menu." + menu.code)
                  }}</span>
                </template>
                <template v-for="child in menu.children">
                  <el-menu-item :index="child.url" :key="child.id">
                    {{
                      activeLang == "zh" || $t("menu." + child.code) == null
                        ? child.name
                        : $t("menu." + child.code)
                    }}
                  </el-menu-item>
                </template>
              </el-submenu>
            </template>
          </el-menu>
          <!-- <el-menu
                      router
                      unique-opened
                      default-active="3-2"
                      :collapse="isCollapse"
                      :collapse-transition="false"
                    >
                      <el-menu-item index="/default">
                        <i class="fa fa-home"></i>
                        <span slot="title">首页</span>
                      </el-menu-item>
                      <el-submenu index="1">
                        <template slot="title">
                          <i class="fa fa-drivers-license-o"></i>系统管理
                        </template>
                        <el-menu-item-group>
                          <el-menu-item index="/user">用户管理</el-menu-item>
                          <el-menu-item index="/role">角色管理</el-menu-item>
                          <el-menu-item index="/menu">菜单管理</el-menu-item>
                        </el-menu-item-group>
                      </el-submenu>
                      <el-submenu index="2">
                        <template slot="title">
                          <i class="fa fa-drivers-license-o"></i>客户管理
                        </template>
                        <el-menu-item-group>
                          <el-menu-item index="/customer/customerCenterMgt"
                            >客户行政区域管理</el-menu-item
                          >
                          <el-menu-item index="/customer/information"
                            >客户基础信息管理</el-menu-item
                          >
                        </el-menu-item-group>
                      </el-submenu>
                      <el-submenu index="3">
                        <template slot="title">
                          <i class="fa fa-cogs"></i>空压机管理
                        </template>
                        <el-menu-item-group>
                          <el-menu-item index="/device/deviceModelMgt"
                            >空压机型号管理</el-menu-item
                          >
                          <el-menu-item index="/ccn">控制器软件CCN及点表</el-menu-item>
                          <el-menu-item index="/gateway">网关管理</el-menu-item>
                          <el-menu-item index="/device/register">空压机登记</el-menu-item>
                        </el-menu-item-group>
                      </el-submenu>
                    </el-menu> -->
        </el-aside>
      </el-scrollbar>

      <slot></slot>
      <!--    </el-container>-->
    </el-container>
  </div>
</template>

<style lang="less"></style>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import {
  GetUserMenu,
  GetAlarmCount,
  authOperationCheck,
  checkLoginFront,
  GetPushMessageCounts,
  getBrandInfos,
  getUserBrand,
  logout,
  getUserAccountType,
  refreshUserToken,
  getSamlLogoutRequest,
  changeMonitorMode,
} from "../../../api/api";
import {
  setItemToLocalstorage,
  delItemFormLocalstorage,
  getItemFormLocalstorage,
} from "../../../../utils/package-localstorage";
import { setCookie, delCookie } from "../../../../utils/package-cookies";
import defaultSettings from "@/config/defaultSettings";

export default {
  name: "MainTabBar",
  components: {},

  data() {
    return {
      userName: "",
      menuList: [],
      currentPage: "/customer/customerCenterMgt",
      alarmNum: "",
      messageNum: "",
      brandCode: "",
      brandList: [],
      brand: "",
      hasMultiAuth: false,
      hasAlarmListAuth: false,
      hasNoticeListAuth: false,
      hasEmcStationMonitor: false,
      accountType: "",
      isRefresh: false,
      roleList: "",
      isAdmin: false,
      refreshCount: 1,
    };
  },
  async created() {
    this.roleList = getItemFormLocalstorage("roles");
    if (this.roleList.indexOf("Admin") != -1) {
      this.isAdmin = true;
    }
    let userBrand = await this.getCurUserBrand();
    if (
      userBrand &&
      userBrand.indexOf(localStorage.getItem("user_brand")) == -1
    ) {
      this.brand = userBrand.split(",")[0];
      this.brandCode = userBrand.split(",")[0];
      localStorage.setItem("user_brand", userBrand.split(",")[0]);
    } else {
      this.brand = localStorage.getItem("user_brand");
      this.brandCode = localStorage.getItem("user_brand");
    }
    let auth = getItemFormLocalstorage("authOperations");
    if (auth.some((a) => a == "MultiBrand_View")) {
      this.hasMultiAuth = true;
    }  
    if (auth.some((a) => a == "EmcStationMonitorScreen_View")) {
      this.hasEmcStationMonitor = true;
    }    
    let isRefresh = localStorage.getItem("isRefresh");
    if (isRefresh == "true") {
      this.isRefresh = true;
    } else {
      this.isRefresh = false;
    }
    //this.activeLang = this.$store.state.language;
    //this.authOperation2(this.$store.state.authOperationState);
    //this.initMenuAuth();
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
      menuListStore: "menuListState",
      authOperationStore: "authOperationState",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
      //activeLang: (state) => state.language,
    }),
  },
  async mounted() {
    checkLoginFront();
    this.getUserName();
    //this.getAlarmCounts();
    this.getPushMessageCounts();
    this.getCurBrand();
    this.getBrandInfos();
    //this.userName = JSON.parse(JSON.stringify(window.localStorage.getItem('userName'))).replace(/"/g,'')
    sessionStorage.setItem("userName", this.userName);
    var cpath = this.$route.path; // location.href;
    cpath = cpath.replace("//", "");
    this.currentPage = cpath.substr(
      cpath.indexOf("/"),
      cpath.length - cpath.indexOf("/")
    );
    if (
      this.menuListStore != null &&
      this.menuListStore != undefined &&
      this.menuListStore.length > 0
    )
      this.menuList = this.menuListStore;
    else {
      if (!getItemFormLocalstorage("menuData")) {
        this.getUserMenu();
        //刷新页面重新绑定菜单
        this.changeLeftnavnum();
      } else {
        this.menuList = getItemFormLocalstorage("menuData");
      }
    }
    this.menuList.forEach((item1) => {
      if (item1.code == "AlarmManagement_View") {
        item1.children.forEach(item2 => {
          if (item2.code == "Alarm_View") {
            this.hasAlarmListAuth = true;
          }
        });
      } else if (item1.code == "SystemManagement_View") {
        item1.children.forEach(item2 => {
          if (item2.code == "BusinessInfoPushList_View") {
            this.hasNoticeListAuth = true;
          }
        });
      }
    });
    this.refreshUserToken();
  },
  methods: {
    ...mapMutations([
      "setLanguage",
      "setMenuListState",
      "setAuthOperationState",
    ]),
    initMenuAuth() {
      if (this.menuListStore) this.menuList = this.menuListStore;
      else {
        if (!getItemFormLocalstorage("menuData")) {
          this.getUserMenu();
          //刷新页面重新绑定菜单
          this.changeLeftnavnum();
        } else {
          this.menuList = getItemFormLocalstorage("menuData");
        }
      }
    },
    async getBrandInfos() {
      let that = this;
      let res = await getBrandInfos();
      that.brandList = res.result;
    },
    changeBrand(brand) {
      let that = this;
      localStorage.setItem("user_brand", brand);
      window.location.reload();
    },
    getCurBrand() {
      this.brandCode = localStorage.getItem("user_brand")
        ? localStorage.getItem("user_brand")
        : "IR";
    },
    async getCurUserBrand() {
      let res = await getUserBrand();
      this.accountType = res.result;
    },
    async getUserAccountType() {
      let that = this;
      let res = await getUserAccountType();
      return res.result;
    },
    changeLanguage(lang) {
      window.localStorage.setItem("user_lang", lang);
      this.setLanguage(lang);
      //this.$router.href.reload();
      window.location.reload();
      // if (window.location.pathname == "/device/deviceInsight") {
      //   let language = "zh";
      //   if (lang == "zh") {
      //     language = "en";
      //   }
      //   let url = window.location.href.replace("lang="+language, "lang="+lang);
      //   window.location.href = url
      // }
      // else{
      //   window.location.reload();
      // }
    },
    openNotice() {
      this.$router.push({ path: "/Alarm/NoticeList" });
    },

    openWarning() {
      this.currentPage = "/Alarm/AlarmList";
      if (
        this.menuListStore != null &&
        this.menuListStore != undefined &&
        this.menuListStore.length > 0
      )
        this.menuList = this.menuListStore;
      else {
        if (!getItemFormLocalstorage("menuData")) {
          this.getUserMenu();
          //刷新页面重新绑定菜单
          this.changeLeftnavnum();
        } else {
          this.menuList = getItemFormLocalstorage("menuData");
        }
      }
      this.$router.push({
        name: "/Alarm/AlarmList",
        params: {
          readStatus: "0",
        },
      });
    },
    // async getAlarmCounts() {
    //   var that = this;
    //   await GetAlarmCount().then((res) => {
    //     if (res.success === true) {
    //       if (res.result == "0") {
    //         that.alarmNum = "";
    //       } else if (parseInt(res.result) > 99) {
    //         that.alarmNum = "···";
    //       } else {
    //         that.alarmNum = res.result;
    //       }
    //       setItemToLocalstorage("AlarmCount", that.alarmNum);
    //     }
    //   });
    // },
    async getPushMessageCounts() {
      var that = this;
      var data = {};
      data.Keyword = "";
      data.SkipCount = 0;
      data.MaxResultCount = 1;

      GetPushMessageCounts(data).then((res) => {
        if (res.success) {
          let counts = res.result.totalCount;
          if (counts == "0") {
            that.messageNum = "";
          } else if (parseInt(counts) > 99) {
            that.messageNum = "···";
          } else {
            that.messageNum = counts;
          }
          setItemToLocalstorage("MessageNum", that.messageNum);
        }
      });
    },
    getUserName() {
      this.userName = getItemFormLocalstorage("userName");
    },
    async password(value) {
      var that = this;
      if (value == "edit") {
        this.$router.push({ path: "/password" });
      } else if (value == "omPlatform") {
        var newWindow = window.open("", "_blank");
        newWindow.location.href = Globals.OMPlatformUrl;
      } else if (value == "layout") {
        var accountType = getItemFormLocalstorage("accountType");
        var userId = getItemFormLocalstorage("userId");
        if (accountType == "sso") {
          this.getSamlLogoutRequest();
        } else {
          logout()
            .then((r) => {
              delCookie("userSessionID");
              delItemFormLocalstorage("userInfo");
              delItemFormLocalstorage("userName");
              delItemFormLocalstorage("auth");
              delItemFormLocalstorage("TokenExpire");
              delItemFormLocalstorage("refreshtime");
              delItemFormLocalstorage("expires_in");
              delItemFormLocalstorage("menuData");
              delItemFormLocalstorage("authOperations");
              delItemFormLocalstorage("AlarmCount");
              delItemFormLocalstorage("isneedchange");
              sessionStorage.clear();
              delCookie("auth");
              delCookie("Abp.AuthToken");
              delCookie("vid");
              this.$router.push({ path: "/login" });
            })
            .catch((err) => {
              this.$router.push({ path: "/login" });
            });
        }
      }
    },

    getSamlLogoutRequest() {
      var that = this;
      let para_brand = "ir";
      let hash = window.location.href;
      if (
        hash.indexOf("testgdweb.irconnectivity.com") >= 0 ||
        hash.indexOf("gdiconn.irconnectivity.com/") >= 0 ||
        hash.indexOf("gdapiconn.irconnectivity.com/") >= 0
      ) {
        para_brand = "gd";
      }
      //var userId = getItemFormLocalstorage("userInfo");
      getSamlLogoutRequest(para_brand, "").then((res) => {
        delCookie("userSessionID");
        delItemFormLocalstorage("userInfo");
        delItemFormLocalstorage("userName");
        delItemFormLocalstorage("auth");
        delItemFormLocalstorage("TokenExpire");
        delItemFormLocalstorage("refreshtime");
        delItemFormLocalstorage("expires_in");
        delItemFormLocalstorage("menuData");
        delItemFormLocalstorage("authOperations");
        delItemFormLocalstorage("AlarmCount");
        delItemFormLocalstorage("isneedchange");
        sessionStorage.clear();
        delCookie("auth");
        delCookie("Abp.AuthToken");
        delCookie("vid");
        var samlUrl = res.result;
        window.location.href = samlUrl;
      });
    },
    // newWin(url) {
    //   var a = document.createElement("a");
    //   a.setAttribute("href", url);
    //   a.setAttribute("target", "_blank");
    //   a.setAttribute("id", "logoutSSOWin");
    //   if (!document.getElementById("logoutSSOWin")) document.body.appendChild(a);
    //   document.getElementById("logoutSSOWin").click();
    //   document.body.removeChild(a);
    // },
    togleCollapse() {
      this.$store.commit("changeCollapse");
    },
    changeLeftnavnum() {
      this.$store.commit("changeLeftnavnum", this.$route.fullPath);
    },
    async getUserMenu() {
      var that = this;
      await GetUserMenu()
        .then(
          (res) => {
            if (res.success === true) {
              that.menuList = res.result;
              that.menuList.map((i) => {
                if (i.children.length == 0) {
                  delete i.children;
                }
              });

              //缓存用户操作权限
              var authOperations = [];
              that.menuList.forEach(function (obj, index) {
                obj.operations.forEach((op1) => {
                  authOperations.push(op1);
                });
                if (obj.children.length > 0) {
                  obj.children.forEach(function (o, i) {
                    o.operations.forEach((op2) => {
                      authOperations.push(op2);
                    });
                  });
                }
              });

              that.setMenuListState(that.menuList);
              that.setAuthOperationState(authOperations);

              setItemToLocalstorage("menuData", that.menuList);
              setItemToLocalstorage("authOperations", authOperations);

              console.log(that.menuList);
            } else {
              if (res.error.code != 401) {
                that.$message.error(res.error.message);
              }
            }
          },
          (err) => {
            if (err.error.code != 401) {
              that.$message.error(err.error.message);
            }
          }
        )
        .catch((err) => {
          if (err.error.code != 401) {
            that.$message.error(err.error.message);
          }
        });
    },
    openScreenMonior() {
      const routeData = this.$router.resolve({
        path: "/ScreenMonitor1",
      });
      window.open(routeData.href, "_blank");
    },
    openStatioMonior() {
      const routeData = this.$router.resolve({
        path: "/StationsMonitor2",
      });
      window.open(routeData.href, "_blank");
    },
    openRoap() {
      window.open(Globals.roapUrl, "_blank");
    },
    openOMPlatform() {
      window.open(Globals.OMPlatformUrl, "_blank");
    },
    openTest() {
      const routeData = "https://testirweb.irconnectivity.com/device/endurance";
      window.open(routeData, "_blank");
    },
    async refreshUserToken() {
      let isRefresh = localStorage.getItem("isRefresh");
      if (isRefresh == "true") {
        this.refreshCount = 1;
        await this.refreshToken();
      }
    },
    async refreshToken() {
      try {
        let res = await refreshUserToken();
        if (res.success === true) {
          this.refreshCount = 1;
          setItemToLocalstorage("auth", res.result.accessToken);
          if (
            res.result.verifyId != undefined &&
            res.result.verifyId != null &&
            res.result.verifyId != ""
          ) {
            setCookie("vid", res.result.verifyId, 1);
          }
          setTimeout(await this.refreshToken, 600 * 1000);
        }
      } catch (error) {
        if (this.refreshCount <= 5) {
          this.refreshCount += 1;
          setTimeout(await this.refreshToken, 5000);
        }
      }
    },
    async changeMonitorMode() {
      localStorage.setItem("isRefresh", this.isRefresh);
      let res = await changeMonitorMode({ isRefresh: this.isRefresh });
      if (this.isRefresh) {
        await this.refreshUserToken();
      }
    },
  },
  watch: {
    $route() {
      //this.handleSelect(//要高亮的菜单index)
      var cpath = this.$route.path; // location.href;
      cpath = cpath.replace("//", "");
      this.currentPage = cpath.substr(
        cpath.indexOf("/"),
        cpath.length - cpath.indexOf("/")
      );
    },
  },
};
</script>
